import ar from '@/local/ar';

export const modalPosition = {
  TOP: 'top',
  MIDDLE: 'middle',
};

export const mode = {
  new: 0,
  update: 1,
  view: 2,
};

export const countryTypeEnum = { saudi: 1 };

export const partyTypeEnum = {
  person: 1, // فرد
  firm: 2, // شركة
  organization: 3, // مؤسسة
  government: 4, // جهة حكومية
  embassy: 5, // سفارة / قنصلية
  association: 6, // جمعيه
  humanSociety: 7, // نسخ دولية وانسانية
  foreignCompany: 9, // شركة أو مؤسسة أجنبية
  institutionWithoutCommercialRegisterNo: 15, // منشأة بدون سجل تجاري
  cessation: 17, // نوع الوقف
  judicialGuard: 18, // حارس قضائي
  liquidator: 19, // مصطفى تركة
};
export const sharedAssetTypeEnum = {
  commonAsset: 1, // مال مشترك
  inheritance: 2, // تركة
};
export const casePartyRoleByIdEnum = {
  1: 'prosecutor',
  2: 'agent',
  3: 'defendant',
  4: 'wiseness',
  5: 'lawyer',
  6: 'relative',
  7: 'journalist',
  8: 'companyRep',
  9: 'other',
  10: 'representative',
  11: 'guardian',
  55: 'judicialGuard',
  56: 'liquidator',
  226: 'translator',
  1000: 'allAttendance',
  1001: 'circle',
  1003: 'otherAttendant',
  1005: 'editor',
  10001: 'execRequester',
  10002: 'requesterAgainstHim',
  2000: 'regent',
  207: 'husband',
  208: 'wife',
  1006: 'terminator',
  206: 'recommender',
  2005: 'minor',
  99: 'dead',
  10005: 'cessationObserver',
  10009: 'reconsideredFromNonCaseParty',
};

export const relativesTypes = {
  father: 1000,
  son: 1001,
  daughter: 1002,
  uncle: 1003,
  brother: 1004,
  Husband: 1005,
  Mother: 1006,
  sister: 1007,
  wife: 1008,
  exWife: 1009,
  paternalUncle: 1010,
};

export const minorTypes = {
  underage: 1,
  mentalDisability: 2,
};

export const casePartyRoleEnum = {
  prosecutor: 1,
  agent: 2,
  defendant: 3,
  wiseness: 4,
  lawyer: 5,
  relative: 6,
  journalist: 7,
  companyRep: 8,
  other: 9,
  representative: 10,
  guardian: 11, // ولي
  appellant: 20, // مستأنف
  appellee: 21, // مستأنف ضده
  judicialGuard: 55,
  liquidator: 56,
  translator: 226,
  allAttendance: 1000,
  circle: 1001,
  otherAttendant: 1003,
  editor: 1005,
  execRequester: 10001,
  requesterAgainstHim: 10002,
  regent: 2000, // وصي
  cessationObserver: 10005,
  inheritor: 10013,
  governmentalRepresentative: 2004,
};

export const actionType = {
  serverAction: 1,
  redirect: 2,
  popup: 3,
  redirectToNewTab: 4,
  gridPrinting: 5,
  addNew: 6,
  edit: 7,
  delete: 8,
  view: 9,
};

export const httpMethod = {
  GET: 1,
  POST: 2,
  PUT: 3,
  DELETE: 4,
  PATCH: 5,
};

export const countriesEnum = { saudiArabia: 1 };

export const professionTypeEnum = {
  firm: 1,
  company: 2,
  government: 3,
  unEmployed: 4,
  diplomaticAuthority: 5,
};

export const professionTypeNameEnum = {
  1: 'مؤسسة',
  2: 'شركة',
  3: 'جهة حكومية',
  4: 'لا يعمل',
  5: 'جهة دبلوماسية',
};

export const socialIdentityTypeEnum = {
  nationalId: 1,
  regularResidency: 2,
  tempResidency: 3,
  passport: 4,
  without: 5,
  other: 6,
  gulfCountry: 7,
  nationalIdBooklet: 8,
  visitor: 13,
  borderNumber: 14,
  identityOfMotamer: 16,
  unifiedNumber: 999999997,
  commercialRegistrationNumber: 999999998,
  organizationId: 999999999,
};

export const writingsOfJusticeEnum = {
  internalAttorney: 1,
  externalAttorney: 2,
};

export const socialIdTypeEnum = {
  1: 'الهوية الوطنية',
  2: 'إقامة نظامية',
  3: 'إقامة مؤقته',
  4: 'جواز سفر',
  5: 'بدون هوية',
  6: 'أخرى',
  7: 'هوية وطنية خليجية',
  8: 'حفيظة نفوس',
  9: 'بطاقة تنقل وعمل',
  13: 'هوية زائر',
  14: 'رقم الحدود',
  16: 'هوية معتمر',
  999999997: 'الرقم الوطني الموحد',
  999999998: 'سجل التجاري',
  999999999: 'رقم',
};

export const requestReplyTypes = {
  Register: {
    id: 1,
    name: 'قيد الطلب',
  },
  NotCompleted: {
    id: 2,
    name: 'غير مكتمل',
  },
  Rejected: {
    id: 3,
    name: 'رفض الطلب',
  },
  TransferToRandomSubCircle: {
    id: 4,
    name: 'إحالة إلى الدائرة القضائية',
  },
  TransferToReconciliation: {
    id: 5,
    name: 'إحالة إلى قسم الصلح',
  },
  TransferToIntendedSubCircle: {
    id: 6,
    name: 'إحالة مرتبطة',
  },
  AcceptedFromAudit: {
    id: 7,
    name: 'إرسال إلى صحائف الدعوى',
  },
  TransferToCourtPresident: {
    id: 8,
    name: 'إرسال إلى رئيس المحكمه',
  },
  SendToCourt: {
    id: 9,
    name: 'ارسال الطلب الى المحكمة',
  },
  CompleteRequest: {
    id: 10,
    name: 'ارسال الطلب الى المحكمة',
  },
  TransferToReconciliationPlatform: {
    id: 11,
    name: 'إحالة الى منصة تراضي',
  },
  SaveRequest: {
    id: 13,
    name: 'حفظ الطلب ',
  },
  CancelRequest: {
    id: 14,
    name: 'إلغاء الطلب',
  },
  PreviousRequestOnTheSameSubject: {
    id: 32,
    name: 'طلب سابق في نفس الموضوع',
  },
  PreviousLawsuitOnTheSameSubject: {
    id: 33,
    name: 'دعوى سابقة في نفس الموضوع',
  },
  RequestNotAvailable: {
    id: 34,
    name: 'طلب غير متاح',
  },
  CancelRequestByApplicant: {
    id: 36,
    name: ' إلغاء الطلب عن طريق مقدم الطلب',
  },
};
export const requestReplyChecklist = {
  isCaseTypeAudited: 'نوع الدعوى',
  isProsecutorListAudited: 'بيانات المدعين',
  isDefendantListAudited: 'بيانات المدعى عليهم',
  isSubjectAudited: 'موضوع الدعوى',
  isDemandsAudited: 'الطلبات',
  isAttachmentsAudited: 'المرفقات',
  isCourtAudited: 'المحكمة المختصة',
  isProofsAudited: 'الأسانيد',
};

export const movementTypes = {
  withDate: {
    id: 1,
    name: 'إحاله بموعد',
  },
  withoutDate: {
    id: 2,
    name: 'إحاله بدون بموعد',
  },
};

export const reportTypes = {
  reporter: {
    id: 1,
    name: 'عن طريق محضر الخصوم',
  },
  phone: {
    id: 9,
    name: 'عن طريق الجوال',
  },
  byProsecutors: {
    id: 2,
    name: 'عن طريق المدعى',
  },
  bySaudiPostal: {
    id: 8,
    name: 'عن طريق البريد السعودي',
  },
};

export const attachmentType = {
  pdf: 1,
  image: 2,
};

export const CRStatus = {
  active: 0,
  expired: 1,
  suspended: 2,
  cancelled: 3,
};
export const caseCategoryEnum = {
  personalStatusEnding: 1, // أحوال شخصية -انهائية
  rights: 2, // حقوقية
  criminalCases: 3, // جزائية
  workers: 4, // عمالية
  criminalCases2: 5, // جزائية
  generalRights: 6, // حقوقي عام
  personalStatus: 7, // أحوال شخصية
  traffic: 8, // مرورية
  commercial: 9, // تجارية
  executing: 10, // تنفيذ
  ending: 11, // انهائية
  rightsCases: 12, // الدعاوى الحقوقية
  trafficCases: 13, // الدعاوى المرورية
  generalTerminations: 14, // الإنهاءات العامة
  personalStatusCases: 15, // دعاوى الأحوال الشخصية
  partialCases: 20, // الدعاوى الجزئية
  endowmentsAndWills: 21, // الأوقاف والوصايا
  cooperativeCriminal: 22, //  جزائي ( مشترك )
  individualCriminal: 23, //   جزائي (فردي)
  realEstateContributions: 24, // المساهمات العقارية
  dividendsOfMoreThan100Million: 25, // قسمة التركات أكثر من 100 مليون
  retributionAndNonSequentialLimitsIndividual: 26, // قصاص وحدود غير إتلافي (فردي)
  senderPunishmentIndividual: 27, // تعزير مرسل(فردي)
  organizedPunishmentIndividual: 28, // تعزير منظم ( فردي )
  juvenile: 29, // الأحداث
  retributionAndLimitsOfDamageCooperative: 30, // قصاص وحدود إتلافي (مشترك)
  generalPunishmentCooperative: 31, //  تعزير عام (مشترك)
  organizedPunishmentCooperative: 32, // تعزير منظم (مشترك)
  financialAndAdministrativeCorruption: 34, // الفساد المالي والإداري
  ratificationOfConfessionIndividual: 2074, // تصديق اعتراف - تعزير فردي
  ratificationOfConfession: 258, // تصديق اعتراف
  ratificationOfTheConviction: 560, // تصديق إقرار قناعة(مشتركة)
  ratificationOfConfessionCommon: 2069, // تصديق اعتراف - تعزير مشترك
  urgentCase: 128, // الدعاوى المستعجلة
};

export const caseTypeEnum = {
  custody: 182,
  arguments: 104,
  financialAmountLawsuit: 345,
  deathDueToAccident: 191, // 'مطالبة بدية متوفى بحادث مرورى أو غيره'
  traffic: 217, // 'دعوى مرورية'
  arbitrationRequest: 66,
  proveTrafficAccidentErrorRate: 2022, // 'إثبات نسبة الخطأ بحادث مروري'
  privateRightBasedOnAccident: 10153,
  publicRightBasedOnAccident: 10155,
  terminations: 10377, // الإنهاءات
  terminationOfTrustOrWill: 10362, // إنهاء وقف أو وصية
  reconsiderationAndProofOfIntegrityAfterCriminalPrecedent: 10001, // رد اعتبار وإثبات الاستقامة بعد السابقة الجنائية
  proofOfNotOwningHouseOrHome: 10033, // إثبات عدم تملك مسكن أو بيت
  authenticationToProveCaseOrCertificateThatHeFearsWillBeMissedWithoutDispute: 10058, // استيثاق لإثبات الحالة أو شهادة يخشى فواتها في غير خصومة
  waiverOfIndemnityOfInjuryOrBloodMoneyotherThanIntentionalAndSemiintentional: 10145, // تنازل عن أرش إصابة أو دية غير العمد وشبه العمد
  generalTermination: 10363, // إنهاء عام
  proofOfOwnershipOfPropertyVacatedInBorderVillages: 10385, // إثبات تملك للعقار الذي تم إخلاؤه في القرى الحدودية
  certificationOfConfession: 10131, // تصديق اعتراف
  proofOfWaiver: 10031, // إثبات تنازل
  financialClaim_feesOfLawyerOrAgent: 10010, // مطالبة مالية - أتعاب محاماة او وكلاء
  judicialRequests_feesOfLawyerOrAgent: 10028, // الطلبات القضائيـة - أتعاب محاماة او وكلاء
  financial_feesOfLawyerOrAgent: 10030, // مالية  - أتعاب محاماة او وكلاء
  financialRights_feesOfLawyerOrAgent: 10032, // حقوق مالية  - أتعاب محاماة او وكلاء
  generalClassification_feesOfLawyerOrAgent: 10203, // التصنيف العام  - أتعاب محاماة او وكلاء
  nonFormalDisputes_feesOfLawyerOrAgent: 10407, // منازعات غير شكلية  - أتعاب محاماة او وكلاء
  guardianshipOverAmentallyMinor: 10412,
  privateRightArisingFromMedicalError: 10400, //حق خاص ناشئ عن خطأ طبي
  laborInspectionToProveTheCondition: 10056, // معاينة عمالية لإثبات الحالة
  generalInspectionToProveTheCondition: 10057, // معاينة عامة لإثبات الحالة
  criminalInspectionToProveTheCondition: 10380, // معاينة جزائية لإثبات الحالة

};

export const argymentTypes = {
  remote: 1, // تقاضي عن بعد
};

export const reconsideringReplyTypes = {
  accept: {
    id: 1,
    name: 'قبول إعادة النظر في القضية المشطوبة',
  },
  reject: {
    id: 2,
    name: 'رفض إعادة النظر في القضية المشطوبة',
  },
};

export const laborContractType = {
  limited: 1,
  unLimited: 2,
};

export const laborContractPaymentType = {
  basic: 1,
  benefits: 2,
};

export const laborContractPaymentMethod = {
  daily: 1,
  monthly: 2,
  weekly: 3,
  byHour: 4,
  byProduction: 5,
  byPiece: 6,
  other: 7,
};

export const laborContractDropReason = {
  resignation: 1,
  drop: 2,
  termination: 3,
  suspension: 4,
  expired: 5,
  other: 6,
};

export const lawsuitRights = {
  general: {
    id: 1,
    name: ar.lawsuitDetails.lawsuitRights.general,
  },
  private: {
    id: 2,
    name: ar.lawsuitDetails.lawsuitRights.private,
  },
};

export const governmentalOrganizations = {
  publicProsecution: {
    id: 154,
    name: 'النيابة العامة',
  },
  investigation: {
    id: 156,
    name: 'هيئة الرقابة و التحقيق',
  },
  police: {
    id: 2073,
    name: 'الشرطة',
  },
  detective: {
    id: 2074,
    name: 'المباحث',
  },
  prison: {
    id: 2075,
    name: 'السجن',
  },
  careHouse: {
    id: 2076,
    name: 'دار الرعاية',
  },
  MinistryOfInteriors: {
    id: 175,
    name: 'وزارة الداخلية',
  },
  MinistryOfDefence: {
    id: 176,
    name: 'وزارة الدفاع',
  },
  NationalAntiCorruptionCommissionOld: {
    id: 152,
    name: 'الهيئة الوطنية لمكافحة الفساد (نزاهة)',
  },
  NationalAntiCorruptionCommission: {
    id: 3457,
    name: 'هيئة الرقابة ومكافحة الفساد (نزاهة)',
  },
};

export const lawsuitRedistributionDepartments = {
  lawsuit: {
    name: 'lawsuit',
    id: 1,
  },
  centralAudit: {
    name: 'central-audit',
    id: 40000,
  },
  servicesCenter: {
    name: 'services-center',
    id: 50000,
  },
};

export const caseJudgmentCourtTypes = {
  highCourt: {
    id: 1,
    name: 'المحكمة العليا',
  },
  appealCourt: {
    id: 2,
    name: 'محكمة الإستئناف',
  },
};
export const supremeAppealCourtType = {
  supreme: 1,
  appeal: 2,
};

export const servicesCenterEmployeeType = {
  consultant: {
    id: 2,
    name: 'المستشارين',
  },
  applicant: {
    id: 3,
    name: 'المدققين',
  },
  // supervisor: {
  //   id: 1,
  //   name: ''
  // },
};

export const lawsuitSource = {
  none: 0,
  portal: 1,
  internal: 2,
  mol: 3,
  publicProsecution: 4,
  servicesCenter: 5,
};

export const userRole = {
  centralAuditHead: 50008,
  centralAuditSupervisor: 50009,
  centralAuditEmployee: 50010,
  centralGeneralAuditEmployee: 50012,
  centralAuditViceHead: 50013,
  servicesCenterSupervisor: 50011,
  servicesCenterAuditEmployee: 60000,
  servicesCenterConsultant: 60001,
  lawsuitDepartmentEmployee: 16,
  lawsuitDepartmentHead: 2013,
  courtPresident: 24,
  courtPresidentAssistant: 2032,
};

export const reconciliationLocationEnum = {
  reconciliationCenterForTaradhi: 1,
  saudiCenterForCommercialArbitration: 2,
  saudiRealEstateArbitrationCenter: 3,

};
export const reconciliationResultEnum = {
  reconciliationUnsuccessfully: 100,
  reconciliationPartialysuccessfully: 101,
  reconciliationArchived: 102,
  reconciliationSuccessfully: 103,
  reconciliationPendingUnderArchived: 104,
  reconciliationInAudit: 105,
  reconciliationInProgress: 106,
};
export const caseFormType = {
  subject: 1,
  requests: 2,
};

export const requestStatus = {
  draft: 1,
  new: 2,
  NotCompleted: 3,
  returnToAudit: 8,
  processing: 43,
  saved: 100,
  canceledForNotBeingReviewd: 15,
  waitingPartiesAuthentications: 127,
  previousRequestOnTheSameSubject: 129,
  previousLawsuitOnTheSameSubject: 130,
  requestNotAvailable: 131,
  canceledFromApplicant: 132,
};
export const caseStatus = {
  //قيد النظر
  inProgress: 2,
  //موقوفة
  stopped: 1009,
  //معلقة بطلب من أطراف الدعوى
  suspendedByCaseParties: 1004,
  //موقفة بطلب من أطراف الدعوى
  stoppedByCaseParties: 3000,
  stoppedByCircleDecision: 3001,
};

export const stopCaseStatus = {
  stopped: 1009,
  suspendedByCaseParties: 1004,
  stoppedByCaseParties: 3000,
  stoppedByCircleDecision: 3001,
};
export const resumeCaseStatus = {
  pendingPrepareStudy: 1,
  pendingInitailReport: 2,
  pendingDiscussion: 3,
  inProgress: 9,
};

export const StopOrResumeRequestStatus = {
  Resume: 1,
  Stop: 2,
  NotApplicable: 3,
};

export const attachmentCategory = {
  residence: 1673, //  إقامة
  prosecutorIdentity: 1685, //  هوية مدعى
  respondentIdentity: 1686, //  هوية مدعى عليه
  agentIdentity: 1687, //  هوية وكيل
  attorneyIdentity: 1688, //   هوية محامى
  attorneyImage: 1875, //  صورة الوكالة
  judgementImage: 1679, // صورة صك الحكم
  letterImage: 1677, // صورة خطاب
  informingDecisionAttachment: 1681, //مرفقات قرار التبليغ
  arbitrationJudgement: 9181, //أصل حكم التحكيم
};

export const attachmentDetections = {
  residentId: 'RESIDENT_ID',
  nationalId: 'NATIONAL_ID',
  nationalIdNew: 'NATIONAL_ID_NEW',
  nationalIdOld: 'NATIONAL_ID_OLD',
};

export const formFieldTypes = {
  text: 1,
  number: 2,
  date: 3,
  selectbox: 4,
  checkbox: 5,
  textarea: 6,
  radioButton: 7,
  multipleSelectBox: 8,
  fieldsSection: 11,
  dataGrid: 22,
};

export const RequestTypes = {
  'add-representative': {
    id: 92,
    name: 'add-representative',
    title: ' طلب إضافة ممثل',
    customComponentName: 'CasePartyRepresentative',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: false,
    showAttachmentSection: true,
    showRequestReasonSection: true,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.addRepresentative.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.addRepresentative.shortExplanation,
    showTag: false,
  },
  'intervenor': {
    id: 93,
    name: 'intervenor',
    title: 'طلب التدخل',
    customComponentName: 'IntervenorRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: false,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.IntervenorRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.IntervenorRequest.shortExplanation,
  },
  'legacyCaseDigitalizationRequest': {
    id: 111,
    name: 'legacyCaseDigitalizationRequest',
    title: 'طلب تحديث بيانات القضية',
    customComponentName: 'CasedigitalizationRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: false,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.legacyCaseDigitalizationRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.legacyCaseDigitalizationRequest.shortExplanation,
  },
  'verdict-objection': {
    id: 70,
    name: 'verdict-objection',
    title: 'طلب الاعتراض على حكم',
    customComponentName: 'VerdictObjectionRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: true,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.VerdictObjectionRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.VerdictObjectionRequest.shortExplanation,
  },
  'reconsideration': {
    id: 7,
    name: 'reconsideration',
    title: 'طلب التماس إعادة نظر',
    customComponentName: 'ReconsiderationRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: true,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.selectbox,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.ReconsiderationRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.ReconsiderationRequest.shortExplanation,
  },
  'joinder': {
    id: 13,
    name: 'joinder',
    title: 'طلب إدخال',
    customComponentName: 'JoinderRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: true,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.JoinderRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.JoinderRequest.shortExplanation,
  },
  'dismissed-request': {
    id: 12,
    name: 'dismissed-request',
    title: 'اعادة النظر فى قضية مشطوبة',
    customComponentName: '',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: true,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.DismissedCaseRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.DismissedCaseRequest.shortExplanation,
  },
  'stop-resume-lawsuit-request': {
    id: 21,
    name: 'stop-resume-lawsuit-request',
    title: 'طلب وقف/استمرار السير في الدعوى',
    customComponentName: 'StopResumeLawsuitRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: true,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.stopResumeLawsuitRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.stopResumeLawsuitRequest.shortExplanation,
  },
  'travel-prevention-request': {
    id: 36,
    name: 'travel-prevention-request',
    title: 'طلب منع من السفر',
    customComponentName: 'TravelPreventionRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: false,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: false,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.travelPreventionRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.travelPreventionRequest.shortExplanation,
  },
  'lift-travel-prevention-request': {
    id: 37,
    name: 'lift-travel-prevention-request',
    title: 'طلب رفع منع من السفر',
    customComponentName: 'LiftTravelPreventionRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: true,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: false,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.checkbox,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.liftTravelPreventionRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.liftTravelPreventionRequest.shortExplanation,
  },
  'correction-Or-Interpretation-Of-Judgment': {
    id: 16,
    name: 'correction-Or-Interpretation-Of-Judgment',
    title: 'طلب تصحيح الحكم أو تفسيره',
    customComponentName: 'CorrectionOrInterpretationOfJudgmentRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: true,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: false,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.correctionOrInterpretationOfJudgmentRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.correctionOrInterpretationOfJudgmentRequest.shortExplanation,
  },
  'remove-agent-from-case-request': {
    id: 44,
    name: 'remove-agent-from-case-request',
    title: 'حذف القضية من الحساب',
    customComponentName: 'RemoveAgentFromCaseRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: false,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: false,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.removeAgentFromCaseRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.removeAgentFromCaseRequest.shortExplanation,
  },
  'funds-hold-request': {
    id: 213,
    name: 'funds-hold-request',
    title: 'طلب الحجز التحفظي على الأموال',
    customComponentName: 'FundsHoldRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: false,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: false,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.fundsHoldRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.fundsHoldRequest.shortExplanation,
  },
  'stop-funds-hold-request': {
    id: 216,
    name: 'stop-funds-hold-request',
    title: 'طلب وقف الحجز التحفظي',
    customComponentName: 'StopFundsHoldRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: true,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.checkbox,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.stopFundsHoldRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.stopFundsHoldRequest.shortExplanation,
  },
  'cassation-request': {
    id: 76,
    name: 'cassation-request',
    title: 'طلب نقض',
    customComponentName: 'CassationRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: true,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: false,
    },
    fullExplanation: ar.caseRelatedRequest.cassationRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.cassationRequest.shortExplanation,
    prerequisites: ['يجب أن يكون الحكم نهائي', 'يجب أن يكون مدة الاعتراضيه للحكم لم تنتهي', 'الطلب خاضع للتكاليف القضائية'],
  },
  'add-note-request': {
    id: 31,
    name: 'add-note-request',
    title: 'طلب إيداع مذكرة',
    customComponentName: 'AddNoteRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: true,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.addNoteRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.addNoteRequest.shortExplanation,
  },
  'judge-rejection-request': {
    id: 8,
    name: 'judge-rejection-request',
    title: 'طلب رد قاضي',
    customComponentName: 'JudgeRejectionRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: true,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.selectbox,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.judgeRejectionRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.judgeRejectionRequest.shortExplanation,
  },
  'litigation-abandonments-request': {
    id: 94,
    name: 'litigation-abandonments-request',
    title: 'طلب ترك الخصومة',
    customComponentName: 'LitigationAbandonmentsRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: false,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.litigationAbandonmentsRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.litigationAbandonmentsRequest.shortExplanation,
  },
  'incidental-request': {
    id: 47,
    name: 'incidental-request',
    title: 'تصحيح الطلب الأصلي او تعديله',
    customComponentName: 'IncidentalRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: true,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.incidentalRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.incidentalRequest.shortExplanation,
    showTag: false,
  },
  'waiver-of-appeal-request': {
    id: 46,
    name: 'waiver-of-appeal-request',
    title: 'طلب إقرار القناعة بالحكم',
    customComponentName: 'waiverOfAppealRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: false,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.waiverOfAppealRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.waiverOfAppealRequest.shortExplanation,
  },
  'lift-refer-request': {
    id: 48,
    name: 'lift-refer-request',
    title: ar.caseRelatedRequest.liftReferRequest.title,
    customComponentName: 'liftReferRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: true,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.liftReferRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.liftReferRequest.shortExplanation,
  },
  'proceed-abandoned-case': {
    id: 49,
    name: 'proceed-abandoned-case',
    title: ar.caseRelatedRequest.proceedAbandonedCase.title,
    customComponentName: 'proceedAbandonedCase',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: true,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.proceedAbandonedCase.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.proceedAbandonedCase.shortExplanation,
  },
  'view-case-record': {
    id: 11,
    name: 'view-case-record',
    title: ar.caseRelatedRequest.viewCaseRecord.title,
    customComponentName: 'viewCaseRecord',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: true,
    showAttachmentSection: false,
    showRequestReasonSection: false,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.viewCaseRecord.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.viewCaseRecord.shortExplanation,
  },
  'correction-judgement-request': {
    id: 106,
    name: 'correction-judgement-request',
    title: ar.caseRelatedRequest.correctionJudgementRequest.title,
    customComponentName: 'correctionJudgementRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: true,
    showAttachmentSection: false,
    showRequestReasonSection: false,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.correctionJudgementRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.correctionJudgementRequest.shortExplanation,
  },
  'interpretation-judgement-request': {
    id: 107,
    name: 'interpretation-judgement-request',
    title: ar.caseRelatedRequest.interpretationJudgementRequest.title,
    customComponentName: 'interpretationJudgementRequest',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: true,
    showAttachmentSection: false,
    showRequestReasonSection: false,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.textarea,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.interpretationJudgementRequest.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.interpretationJudgementRequest.shortExplanation,
  },
  'reconsideration-from-non-case-party': {
    id: 50,
    name: 'reconsideration-from-non-case-party',
    title: ar.caseRelatedRequest.reconsiderationFromNonCaseParty.title,
    customComponentName: 'reconsiderationFromNonCaseParty',
    requestReasonsType: 'list',
    showDefaultRequestApplicantSection: false,
    showAttachmentSection: false,
    showRequestReasonSection: true,
    isEnabled: true,
    requestReasonTypeConfig: {
      fieldType: formFieldTypes.selectbox,
      showRequestReasonAttachment: true,
    },
    fullExplanation: ar.caseRelatedRequest.reconsiderationFromNonCaseParty.fullExplanation,
    shortExplanation: ar.caseRelatedRequest.reconsiderationFromNonCaseParty.shortExplanation,
  },
  'waiver-request': {
    id: 112,
    name: 'waiver-request',
    title: ar.waiverRequest.title,
    customComponentName: 'waiverRequest',
    showAttachmentSection: true,
    requestReasonTypeConfig: { fieldType: formFieldTypes.selectbox },
  },
};

export const RequestTypesIds = {
  92: 'add-representative',
  93: 'intervenor',
  70: 'verdict-objection',
  7: 'reconsideration',
  13: 'joinder',
  11: 'view-case-record',
  12: 'dismissed-request',
  21: 'stop-resume-lawsuit-request',
  36: 'travel-prevention-request',
  37: 'lift-travel-prevention-request',
  217: 'lift-precautionary-seizure-request',
  16: 'correction-Or-Interpretation-Of-Judgment',
  44: 'remove-agent-from-case-request',
  213: 'funds-hold-request',
  216: 'stop-funds-hold-request',
  76: 'cassation-request',
  31: 'add-note-request',
  8: 'judge-rejection-request',
  94: 'litigation-abandonments-request',
  47: 'incidental-request',
  46: 'waiver-of-appeal-request',
  48: 'lift-refer-request',
  49: 'proceed-abandoned-case',
  106: 'correction-judgement-request',
  107: 'interpretation-judgement-request',
  50: 'reconsideration-from-non-case-party',
  112: 'waiver-request',
};

export const ProcedureStatus = {
  new: 1,
  inComplete: 2,
  reconsiled: 3, //accepted
  completed: 4,
  processing: 5,
  canceled: 6,
};
export const judgementSection = {
  waqae: 1,
  reasons: 2,
  mantoq: 3,
  other: 4,
};
export const RequestTypesNames = {
  addRepresentative: RequestTypes['add-representative'],
  intervenor: RequestTypes['intervenor'],
  legacyCaseDigitalizationRequest: RequestTypes['legacyCaseDigitalizationRequest'],
  verdictObjection: RequestTypes['verdict-objection'],
  joinder: RequestTypes['joinder'],
  dismissedRequest: RequestTypes['dismissed-request'],
  stopResumeLawsuitRequest: RequestTypes['stop-resume-lawsuit-request'],
  waiverRequest: RequestTypes['waiver-request'],
  travelPreventionRequest: RequestTypes['travel-prevention-request'],
  liftTravelPreventionRequest: RequestTypes['lift-travel-prevention-request'],
  liftPrecautionarySeizureRequest: RequestTypes['lift-precautionary-seizure-request'],
  correctionOrInterpretationOfJudgment: RequestTypes['correction-Or-Interpretation-Of-Judgment'],
  removeAgentFromCaseRequest: RequestTypes['remove-agent-from-case-request'],
  fundsHoldRequest: RequestTypes['funds-hold-request'],
  stopFundsHoldRequest: RequestTypes['stop-funds-hold-request'],
  cassationRequest: RequestTypes['cassation-request'],
  addNoteRequest: RequestTypes['add-note-request'],
  judgeRejectionRequest: RequestTypes['judge-rejection-request'],
  litigationAbandonmentsRequest: RequestTypes['litigation-abandonments-request'],
  incidentalRequest: RequestTypes['incidental-request'],
  waiverOfAppealRequest: RequestTypes['waiver-of-appeal-request'],
  liftReferRequest: RequestTypes['lift-refer-request'],
  proceedAbandonedCase: RequestTypes['proceed-abandoned-case'],
  viewCaseRecord: RequestTypes['view-case-record'],
  correctionJudgementRequest: RequestTypes['correction-judgement-request'],
  interpretationJudgementRequest: RequestTypes['interpretation-judgement-request'],
  reconsiderationFromNonCaseParty: RequestTypes['reconsideration-from-non-case-party'],
  reconsideration: RequestTypes['reconsideration'],
};
export const socialTypes = {
  socialId: 1,
  unifiedNumber: 2,
};
export const CaseRelatedRequestReplyTypes = {
  acceptRequestAction: 1,
  notCompletedRequestAction: 2,
  rejectRequestAction: 3,
  receiveRequestAction: 10,
  submitNewRequest: 16,
  completeRequestAction: 17,
};

export const caseClassificationEnum = {
  family: 1,
  commercial: 2,
  execution: 3,
  criminal: 4,
  general: 5,
  labor: 6,
  proofs: 7,
};

export const regulationTypesEnum = {
  regulation: 1,
  rule: 2,
  roster: 3,
  item: 4,
  principle: 5,
  decision: 6,
  generalization: 7,
};

export const dynamicFormActivationStatus = {
  notActivated: 0,
  activatedOnInternalSystem: 1,
  activatedOnPortal: 2,
  activatedOnInternalSystemAndPortal: 3,
};

export const sessionTypes = {
  pleadingSession: 2,
  judgmentHearingSession: 3,
  elitigationSession: 4,
  remoteArgument: 12,
  firstHearingSession: 13,
  expert: 31,
  caseManagementELitigation: 34,
  secretWitnessSession: 15,
};

export const judgmentTypes = {
  final: 1,
  nonFinalJudgement: 2,
};

export const courtDegrees = [
  {
    text: ar.grades.first,
    key: 1,
  },
  {
    text: ar.grades.appeal,
    key: 2,
  },
  {
    text: ar.grades.higher,
    key: 3,
  },
];

export const partiesAuthenticationEnum = {
  refusedAuthentication: 0,
  acceptAuthentication: 1,
  editAuthenticationData: 2,
};
export const sessionStatus = {
  new: 1,
  inProgress: 2,
  finished: 3,
  canceled: 4,
  newHearing: 5,
  inProgressHearing: 6,
};

export const stopOrResumeLawsuitRequestTypeValues = {
  stopLawsuitRequestType: 1,
  resumeLawsuitRequestType: 2,
};

export const caseDegrees = {
  1: ar.grades.first,
  2: ar.grades.appeal,
  3: ar.grades.higher,
};

export const casePartyStatus = {
  active: 1,
  abandoned: 4,
};

export const userType = {
  internalUser: 0,
  najizCitizen: 1,
  integration: 2,
  najizOrganization: 3,
  najizServicesCenter: 4,
  najizLawyer: 5,
  healthAffairs: 6,
  MOHComplianceManagement: 7,
};
export const yesOrNoEnum = {
  yes: 1,
  no: 2,
};

export const judicialInformingApproachEnum = {
  forensicReportingPlatform: 1,
  other: 2,
};

export const Urls = { oldPortal: '/applications/courts/lawsuits-requests' };

export const attorneyActions = {
  updateAttorneyDetails: 1,
  submitRemoveRepresentativeRequest: 2,
};

export const billStatus = {
  draft: 1,
  pendingApproval: 2,
  created: 3,
  confirmed: 4,
  canceled: 5,
  failedToCreateInvoice: 6,
  paid: 7,
  excluded: 8,
  canceledByReview: 9,
  zeroAmountBill: 10,
  hasObjection: 11,
  refundRequested: 12,
  refundConfirmed: 13,
  fullyRefunded: 14,
  partiallyRefunded: 15,
  failedToCreateRefundRequested: 16,
  expired: 17,
};

export const litigationAbandonmentDefendantsResponseText = {
  0: 'لم يتم الرد',
  1: 'تم القبول',
  2: 'تم الرفض',
};

export const litigationAbandonmentDefendantsResponseEnum = {
  noReply: 0,
  accepted: 1,
  rejected: 2,
};

export const WaiverOfAppealResponseEnum = {
  noReply: 3,
  accepted: 1,
  rejected: 2,
};

export const WaiverOfAppealResponseText = {
  0: 'لم يتم الرد',
  1: 'تم القبول',
  2: 'تم الرفض',
};

export const billActionType = {
  refundDone: 17,
  confirmUpdateInvoice: 21,
};
export const incidentalRequestsRequestTypeText = {
  true: 'مالي',
  false: 'غير مالي',
};

export const incidentalRequestsRequestStatusEnum = {
  new: 1,
  deleted: 2,
  modified: 3,
  original: 4,
};

export const incidentalRequestsRequestStatusText = {
  1: 'جديد',
  2: 'ملغي',
  3: 'تم التعديل عليه',
  4: 'أصلي',
};
export const representationTypeSelection = {
  representativeSelection: 1,
  lawyerSelection: 2,
};
export const attestationSigningMethod = { fromPortal: 5 };
export const attestationSigningOption = {
  accept: 1,
  reject: 2,
};

export const commercialRegistrationTypes = [
  {
    id: 0,
    name: 'رئيسي',
  },
  {
    id: 1,
    name: 'فرعي',
  },
];
export const archiveActions = {
  canArchiveTheCase: 1,
  canCancelArchivingTheCase: 2,
  notApplicaple: 3,
};
export const otpServiceId = {
  archiveCase: 100,
  unArchiveCase: 101,
  viewArchivedCases: 103,
};
export const similarCaseTypes = { feesOfLawyer: 1 };

export const nafathStatus = {
  waiting: 'WAITING',
  expired: 'EXPIRED',
  rejected: 'REJECTED',
  completed: 'COMPLETED',
};

export const nafathServiceTypes = {
  archivingTheCase: 'ArchivingtheCase',
  inquireAboutTheJudgmentDeed: 'InquireAbouttheJudgmentDeed',
};

export const applicantRole = {
  original: 1,
  representative: 2,
  organizationRepresentative: 3,
};

export const incomingRequestType = {
  joinder: 1, // مدخل لمصلحة العدالة
  secretWitness: 2, // شاهد سري
};

export const judgementDeliveryStatus = { read: 6 };

export const waiverAttachmentTypes = {
  repairReportAttachment: 1900,
  conditionValideAttachment: 1901,
  otherAttachment: 1869,
};

export const waiverTypeEnum = {
  waiverWithoutConditions: 1,
  waiverWithConditions: 2,
};

export const decisionTypeEnum = { supremeCourtDecision: 38 };